import { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {FormDialog, FormSelect} from "../../../controls";
import { useAircraftTypes } from '../../../services/aircraft';

const AirportPopulateCostsDialog = (props) => {
  const SystemData = props.SystemData;
  const eventBus = SystemData.eventBus;
  const classes = props.classes

  const aircraftTypes = useAircraftTypes({});

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    record: {},
    title: 'Select Aircraft Type to Populate Costs for',
    message: null,
  });

  useEffect(()=> {
    const open = async (params) => {
      const {record, title, canEdit, message} = params;

      setDialogState({...dialogState, showDialog: true, record, title, canEdit, message});
    }
    eventBus.bind("AirportPopulateCostsDialog.open", open);
    return () => {
      eventBus.unbind("AirportPopulateCostsDialog.open", open);
    }
  }, [dialogState, eventBus, setDialogState]);

  return (
    <FormDialog
      title={dialogState.title}
      message={dialogState.message}
      open={dialogState.showDialog}
      record={dialogState.record}
      dialogOptions={{width: "lg", maxWidth: "lg"}}
      classes={classes}
      //validator={Validator}
      buttons = {{
        save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
        cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
      }}
      onChange={(state) => {
        if (state.buttonPressed === "save") {
          const record = state.record;
          props.onChange(record);
          setDialogState({...dialogState, showDialog: false, record: {}, title: '', message: null});
        } else {
          setDialogState({...dialogState, showDialog: false, record: {}, title: '', message: null});
        }
      }}

    >
      <Grid container checkChildren={true} spacing={3}>
        <Grid item xs={12} checkChildren={true}>
          {(record) => (
            <FormSelect
              name="aircraftType"
              label="Aircraft Type"
              options={aircraftTypes.data || []}
              value={record.aircraftType}
            />
          )}
        </Grid>
      </Grid>
    </FormDialog>
  )

}

export default AirportPopulateCostsDialog;
